import {Group, Select, Text, ThemeIcon} from "@mantine/core";
import classes from "./SettingSelectField.module.css";
import {useTranslation} from "react-i18next";
import {useLocalStorage} from "@mantine/hooks";
import IconLayoutSidebarLeft from "../../../../assets/layout-sidebar.svg?react";
import IconLayoutSidebarRight from "../../../../assets/layout-sidebar-right.svg?react";
import {
    SidebarPosition,
    SIDEBAR_POSITION_STORAGE_KEY,
    DEFAULT_SIDEBAR_POSITION,
} from "../../hooks/useSidebarPosition";

export function SidebarPositionSelectField() {
    const {t} = useTranslation();
    const [position, setPosition] = useLocalStorage<SidebarPosition>({
        key: SIDEBAR_POSITION_STORAGE_KEY,
        defaultValue: DEFAULT_SIDEBAR_POSITION,
    });

    const handlePositionChange = (value: string | null) => {
        if (value === SidebarPosition.Left || value === SidebarPosition.Right) {
            setPosition(value as SidebarPosition);
        }
    };

    return (
        <Group className={classes.outer}>
            <Text className={classes.innerItem}>
                {t("settings.sidebarPosition")}
            </Text>
            <Select
                className={classes.innerItem}
                leftSection={
                    <ThemeIcon
                        variant="light"
                        size="sm"
                        radius="xl"
                        color="gneis.8"
                        bg="transparent"
                    >
                        {position === SidebarPosition.Left ? (
                            <IconLayoutSidebarLeft width={16} />
                        ) : (
                            <IconLayoutSidebarRight width={16} />
                        )}
                    </ThemeIcon>
                }
                data={[
                    {
                        value: SidebarPosition.Left,
                        label: t("settings.field.sidebarPosition.left"),
                    },
                    {
                        value: SidebarPosition.Right,
                        label: t("settings.field.sidebarPosition.right"),
                    },
                ]}
                value={position}
                onChange={handlePositionChange}
            />
        </Group>
    );
}
